import { post, get, put, deleteApi } from '../axiosFun';
/* 培训课程 */
// 分页
const planPage = data => {
  return post('/train/plan/page', data)
};
// 列表
const planList = data => {
  return post('/train/plan/list', data)
};
// 详情
const planDetail = planId => {
  return get('/train/plan/detail/' + planId)
};
// 新增
const planAdd = data => {
  return post('/train/plan/add', data)
};
// 编辑
const planEdit = data => {
  return put('/train/plan/edit', data)
};
// 删除
const planRemove = data => {
  return deleteApi('/train/plan/remove', data)
};
// 发布
const planPublish = data => {
  return post('/train/plan/publish', data)
};
// 获取发布状态
const planPublishStatus = planId => {
  return get('/train/plan/publishStatus/' + planId)
};
// 训记录表
const trainTable = planId => {
  return get('/train/plan/trainTable/' + planId)
};

// 有效性评估编辑
const editEstimate = data => {
  return post('/train/plan/editEstimate', data)
};
export default {
  planPage,
  planList,
  planDetail,
  planAdd,
  planEdit,
  planRemove,
  planPublish,
  planPublishStatus,
  trainTable,
  editEstimate
}




// WEBPACK FOOTER //
// ./src/api/onlineTraining/trainingPlan.js